import { defineComponent as _defineComponent } from 'vue'
import { IProductDetailFooter, IProductDetailFooterAction } from '@/modules/catalog/services/products';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, InitialAvatarIcon, Row } from '@warrenbrasil/nebraska-web';

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetFooter',
  props: {
  footer: {
    type: Array as PropType<IProductDetailFooter[]>,
    default: null
  },
  footerActions: {
    type: Array as PropType<IProductDetailFooterAction[]>,
    default: null
  },
  shouldRenderAdditionalInfo: {
    type: Boolean,
    default: false
  }
},
  emits: ['open-additional-info'],
  setup(__props, { emit }) {





return { __sfc: true,emit, NebraskaColors, BaseText, InitialAvatarIcon, Row }
}

})